import React from "react";
import { Layout, Breadcrumb, Card, Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { routesAdminData, baseAdminPath } from "../../routes";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const onLink = (path) => {
    navigate(path);
  };
  const newRouters = [];
  routesAdminData.forEach((item) => {
    if (!item.children) {
      newRouters.push({
        ...item,
        path: `/${baseAdminPath}/${item.path}`,
      });
    } else {
      item.children.forEach((ele) => {
        newRouters.push({
          ...ele,
          path: `/${baseAdminPath}/${item.path}/${ele.path}`,
        });
      });
    }
  });
  console.log("newRouters", newRouters);
  const currentRouter = newRouters.find(
    (item) => item.path === location.pathname
  );
  return (
    <>
      <Sider width={160} className="layout-sider">
        <Menu
          mode="inline"
          defaultSelectedKeys={currentRouter && [currentRouter.path]}
          defaultOpenKeys={currentRouter && [currentRouter.path]}
          style={{ height: "100%", borderRight: 0 }}
        >
          {routesAdminData.map((ele) => {
            if (ele.children) {
              return (
                <SubMenu
                  key={ele.title}
                  icon={<UserOutlined />}
                  title={ele.title}
                >
                  {ele.children.map((item) => {
                    const path = `/${baseAdminPath}/${ele.path}/${item.path}`;
                    return (
                      <Menu.Item key={path} onClick={onLink.bind(this, path)}>
                        {item.title}
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              );
            } else {
              const path = `/${baseAdminPath}/${ele.path}`;
              return (
                <Menu.Item key={path} onClick={onLink.bind(this, path)}>
                  {ele.title}
                </Menu.Item>
              );
            }
          })}
        </Menu>
      </Sider>
      <Layout className="layout-container" style={{ height: "100%", overflow: 'hidden' }}>
        {currentRouter && currentRouter.breadcrumb && (
          <Breadcrumb style={{ margin: "6px 0" }}>
            {currentRouter.breadcrumb.map((ele) => (
              <Breadcrumb.Item key={ele.title}>{ele.title}</Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
        <Content style={{ height: "100%", overflowY: 'auto' }}>
          <Card style={{ minHeight: "100%" }}>
            <Outlet />
          </Card>
        </Content>
      </Layout>
    </>
  );
};

export default AdminLayout;
